// GENERAL
import React from "react";

// TYPES
import { HeaderCellInfiniteScrollTypes } from "../../types";
import { ColumnInstance } from "react-table";
// COMPONENTS
import TableHeaderContent from "@agilant/toga-blox/dist/components/TableHeaderContent/TableHeaderContent";
import HeaderFilterIcon from "@agilant/toga-blox/dist/components/HeaderFilterIcon/HeaderFilterIcon";
import SupplyPortal from "../../../../SupplyPortal";
import SortArrows from "../tableActions/SortArrows";
import InputAndCheck from "../tableActions/InputAndCheck";

const PortalOverlay: React.FC = () => (
	<SupplyPortal containerId="portal-root">
		<div className="w-full h-full absolute top-0"></div>
	</SupplyPortal>
);

const HeaderCellInfiniteScroll = <T extends object>({
	roundedClasses,
	column,
	isLeftColumnStickyHeader,
	editingHeader,
	setEditingHeader,
	inputRef,
	containerRef,
	slug,
	mappingField,
	searchResultsPillColor,
	filterIcon,
	filterWeight,
	activeCols,
	columnIndex,
	setSearchColumn,
	searchText,
	setHeaderValue,
	isTableSearchAndSortEnabled = true,
	parentIndex = 0,
	isNested = false,
	setSortColumn,
	handleSortChange,
	magnifyingIconRef,
	columnIsRightActionBar,
	updatedColumn,
}: HeaderCellInfiniteScrollTypes<T>) => {
	return (
		<>
			<th
				className={`text-navy-500 font-omnes-medium font-medium text-sm whitespace-nowrap ${roundedClasses} bg-supply-blue-50 ${
					columnIsRightActionBar ? "px-10" : "px-5"
				}`}
				{...column.getHeaderProps()}
				style={{
					// pull in React‑Table’s computed width & minWidth
					...column.getHeaderProps().style,
					// then layer on our sticky rules
					position: "sticky",
					top: 0,
					// background: "var(--supply-blue-50)",
					zIndex: isLeftColumnStickyHeader ? 60 : 50,
					...(isLeftColumnStickyHeader && {
						left: column.getHeaderProps().style?.left,
					}),
				}}
			>
				<div
					className={` items-center text-sm min-h-8 flex break-words whitespace-normal rounded-lg relative `}
				>
					{editingHeader === columnIndex ? (
						<>
							<TableHeaderContent column={updatedColumn} />
							<div
								className="absolute w-full top-[-5px] bottom-4 "
								ref={containerRef}
							>
								<div className="absolute top-10 z-20 bg-white w-max">
									<InputAndCheck
										slug={slug}
										columnSlug={mappingField}
										setEditingHeader={setEditingHeader}
										column={updatedColumn}
										closeOutSearch={() =>
											setEditingHeader(null)
										}
										setResetSearch={() => []}
										pillColor={searchResultsPillColor}
									/>
									{(() => {
										inputRef.current?.focus();
										return null;
									})()}
								</div>
							</div>
							<PortalOverlay />
						</>
					) : (
						<TableHeaderContent column={updatedColumn} />
					)}
					<div className="ml-1">
						{isTableSearchAndSortEnabled && (
							<SortArrows
								slug={mappingField || ""}
								parentIndex={parentIndex}
								isNested={isNested}
								column={{
									...updatedColumn,
									accessor: String(updatedColumn.accessor),
								}}
								setSortColumn={setSortColumn}
								onSortChange={handleSortChange}
							/>
						)}
					</div>
					{filterIcon && (
						<HeaderFilterIcon
							ref={magnifyingIconRef}
							editingHeader={editingHeader}
							columnIndex={columnIndex}
							column={updatedColumn as ColumnInstance<any>}
							setEditingHeader={setEditingHeader}
							setHeaderValue={setHeaderValue}
							searchText={searchText}
							isActive={activeCols.includes(columnIndex)}
							isSearchOpen={editingHeader !== null}
							additionalIconClasses={
								activeCols.includes(columnIndex)
									? "text-white"
									: "text-navy-400"
							}
							iconActiveBackgroundColor="bg-supply-blue-400"
							setActiveColumn={setSearchColumn}
							icon={{
								icon: filterIcon,
								weight: filterWeight as
									| "solid"
									| "regular"
									| "light",
							}}
							itemHoverColor="hover:bg-white"
							iconActiveColor="text-white"
						/>
					)}
					{/* {isCopyable && (
					<div>
						<CopyToClipboardIconWrapper
							text={""}
							withText
							hasIconBorder={false}
							copyText="Copy All"
							lastCopiedText={""}
							onClick={handleCopyAll}
						/>
					</div>
				)} */}
				</div>
			</th>
		</>
	);
};

export default HeaderCellInfiniteScroll;
